module.exports = __webpack_public_path__ + "static/media/report.caae7bf0.svg";